import { getPostHog } from './_posthog.client';

export function captureException(error: Error, properties?: Record<string, unknown>) {
  getPostHog()?.captureException(error, properties);
}
